import { render, staticRenderFns } from "./MyMastercardWallet.vue?vue&type=template&id=2d846bcc&"
import script from "./MyMastercardWallet.vue?vue&type=script&lang=js&"
export * from "./MyMastercardWallet.vue?vue&type=script&lang=js&"
import style0 from "./MyMastercardWallet.vue?vue&type=style&index=0&id=2d846bcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports